import { IconComponentProps } from '../IconTypes';

const ChevronDown = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0001 13.3048L15.9337 9.37123C16.1759 9.12513 16.5728 9.12716 16.8169 9.37091C17.0611 9.61466 17.0611 10.0104 16.8169 10.2545L12.4419 14.6295C12.32 14.7516 12.1603 14.8126 12.0001 14.8126C11.84 14.8126 11.6798 14.7501 11.5579 14.6298L7.18294 10.2548C6.9388 10.0111 6.93919 9.61537 7.18294 9.37123C7.42669 9.12709 7.82239 9.12709 8.06653 9.37123L12.0001 13.3048Z"
      fill="#113183"
    />
  </svg>
);

export default ChevronDown;
